// @flow

import { setCookie, getCookie, deleteCookie } from './cookie';

const TOKEN_KEY      = 'recruiters_token';
const EXPIRES_AT_KEY = 'recruiters_token_expires_at';

export const getExpiresAt = () => Number(localStorage.getItem(EXPIRES_AT_KEY));
export const getExpiresAtCookies = () => Number(getCookie(EXPIRES_AT_KEY));

export const getToken = (): ?string => {
  const expiresAt = getExpiresAt();

  if (expiresAt === null || expiresAt > Date.now() || getExpiresAtCookies() > Date.now()) {
    return localStorage.getItem(TOKEN_KEY);
  }

  return null;
};

export const setToken = ({ token, expiresAt }: { token: string, expiresAt: string }) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_AT_KEY, expiresAt);
  setCookie(TOKEN_KEY, token, expiresAt);
};

export const removeToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(EXPIRES_AT_KEY);
  deleteCookie(TOKEN_KEY);
};

export const hasToken = (): boolean => getToken() !== null;
